import React from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { COLORS, CONTENT_MAX_WIDTH, FONT } from "../shared/styles";
import { SearchIcon } from "./icons";

function CannedSearchBar({ value, onChange }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        mt: "24px",
      }}
    >
      <TextField
        type="text"
        placeholder="Search canned responses"
        value={value}
        onChange={onChange}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ mr: "8px" }}>
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 16,
                  height: 16,
                  flexShrink: 0,
                }}
              >
                <SearchIcon />
              </Box>
            </InputAdornment>
          ),
        }}
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            height: "40px",
            borderRadius: "8px",
            fontFamily: FONT.family,
            fontSize: "14px",
            fontWeight: 400,
            color: COLORS.textPrimary,
            boxShadow: COLORS.shadow,
            background: COLORS.white,
            pl: "16px",
            "& fieldset": {
              borderColor: COLORS.border,
            },
            "&:hover fieldset": {
              borderColor: COLORS.border,
            },
            "&.Mui-focused fieldset": {
              borderColor: COLORS.primary,
            },
          },
          "& .MuiOutlinedInput-input": {
            py: 0,
            px: 0,
            pr: "12px",
            "&::placeholder": {
              color: COLORS.textPlaceholder,
              opacity: 1,
            },
          },
        }}
      />
    </Box>
  );
}

export default CannedSearchBar;
